import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import EditorialMarquee from "../components/site/Marquee";
import Featured from "../components/site/Featured";
import Phase1 from "../components/site/Phase1";
import Battery from "../components/site/Battery";
import WhyChoose from "../components/site/WhyChoose";
import About from "../components/site/About";
import Roadmap from "../components/site/Roadmap";
import Contact from "../components/site/Contact";
import Newsletter from "../components/site/Newsletter";
import Footer from "../components/site/Footer";

function Preloader({ done }) {
  return (
    <div
      className={`fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center transition-opacity duration-700 ${
        done ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      data-testid="preloader"
    >
      <div className="text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="font-display text-4xl md:text-6xl font-black uppercase tracking-tighter text-white"
        >
          SOB<span className="text-orange-500">TREX</span>
        </motion.div>
        <div className="mt-6 h-0.5 w-48 mx-auto bg-zinc-800 overflow-hidden">
          <motion.div
            className="h-full bg-orange-500"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 1.1, ease: "easeInOut" }}
          />
        </div>
        <p className="mt-4 text-[10px] font-bold uppercase tracking-[0.4em] text-zinc-600">Industrial &amp; Power Tools</p>
      </div>
    </div>
  );
}

export default function Landing() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    document.title = "Sobtrex | Professional Power Tools | Coming Soon";
    const t = setTimeout(() => setDone(true), 1300);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="bg-[#050505]">
      <Preloader done={done} />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Featured />
        <Phase1 />
        <Battery />
        <WhyChoose />
        <About />
        <Roadmap />
        <Contact />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
